import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgNotification({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2a1 1 0 011 1l.001.062A8.001 8.001 0 0120 11v6a1 1 0 01.117 1.993L20 19h-4.126a4.002 4.002 0 01-7.748 0H4a1 1 0 110-2v-6a8.001 8.001 0 017-7.938V3a1 1 0 011-1zm1.732 17.001h-3.464a1.999 1.999 0 003.464 0zM12 5a6 6 0 00-6 6v6h12v-6a6 6 0 00-6-6z"
        fill={color}
      />
    </svg>
  )
}

export default SvgNotification
